module.exports = __webpack_public_path__ + "img/00027.198eda2c.webp";